/**
 * Date-string utilities shared across list filters.
 */

/**
 * Strict ISO calendar-date pattern (YYYY-MM-DD). Used to allowlist-validate
 * date strings coming from URL params before they're seeded into filter state
 * or sent to the backend — a crafted value can't smuggle anything past this.
 */
export const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
